import React from 'react';
import './validationLabel.css';
export default function ValidationError({ classError = 'lblerror', txtLbl }) {
  return (
    <label className={classError} htmlFor="">
      {txtLbl}
    </label>
  );
}
